import Actions from 'flow/actions';
import {
    networkErrorDispatcher,
    httpGetErrorDispatcher,
} from 'flow/actions/app-actions';
import IntegrationAccessResource from 'flow/api/integrationaccess';

export const fetchIntegrationAccessTokens =
    (extensionEntityKey) => (dispatch) => {
        IntegrationAccessResource.getIntegrationAccessTokens(
            {
                onResult(json) {
                    dispatch(receiveIntegrationAccessTokens(json));
                },
                onError: httpGetErrorDispatcher(dispatch),
            },
            extensionEntityKey,
        );
    };

export const fetchIntegrationAccessDomains = () => (dispatch) => {
    IntegrationAccessResource.getIntegrationAccessDomains({
        onResult(json) {
            dispatch(receiveIntegrationAccessDomains(json));
        },
        onError: httpGetErrorDispatcher(dispatch),
    });
};

export const createIntegrationAccessToken =
    (extensionKey, domainEntityKey, description, expiresIn, callback) =>
    (dispatch) => {
        IntegrationAccessResource.createIntegrationAccessToken(
            {
                onResult(json) {
                    callback?.(json);
                    dispatch(receiveCreatedIntegrationAccessToken(json));
                },
                onError: networkErrorDispatcher(dispatch),
            },
            extensionKey,
            domainEntityKey,
            description,
            expiresIn,
        );
    };

export const createIntegrationAccessTokenForLoggedInUser =
    (domainEntityKey, description, expiresIn, callback) => (dispatch) => {
        IntegrationAccessResource.createIntegrationAccessTokenForLoggedInUser(
            {
                onResult(json) {
                    callback?.(json);
                },
                onError: networkErrorDispatcher(dispatch),
            },
            domainEntityKey,
            description,
            expiresIn,
        );
    };

export const updateIntegrationAccessToken =
    (
        extensionKey,
        integrationAccessKey,
        integrationAccessDTO,
        onComplete = null,
    ) =>
    (dispatch) => {
        IntegrationAccessResource.updateIntegrationAccessToken(
            {
                onResult(json) {
                    dispatch(receiveIntegrationAccessTokens(json));
                    if (onComplete) {
                        onComplete();
                    }
                },
                onError(...args) {
                    if (onComplete) {
                        onComplete();
                    }
                    return networkErrorDispatcher(dispatch)(...args);
                },
                // A 4xx, e.g. 404 for a token already deleted, must not stall the caller.
                onClientError() {
                    if (onComplete) {
                        onComplete();
                    }
                },
            },
            extensionKey,
            integrationAccessKey,
            integrationAccessDTO,
        );
    };

export const clearCreatedToken = () => {
    return {
        type: Actions.CLEAR_CREATED_ACCESS_TOKEN,
    };
};

const receiveIntegrationAccessTokens = (json) => {
    return {
        type: Actions.RESULT_INTEGRATION_ACCESS_TOKENS,
        data: json,
    };
};

const receiveIntegrationAccessDomains = (json) => {
    return {
        type: Actions.RESULT_INTEGRATION_ACCESS_DOMAINS,
        data: json,
    };
};

const receiveCreatedIntegrationAccessToken = (json) => {
    return {
        type: Actions.RESULT_CREATE_INTEGRATION_ACCESS_TOKEN,
        data: json,
    };
};
